import { Field } from "formik";
import React, { useEffect, useState } from "react";
import * as yup from "yup";
import DefaultActionButtonGenerator, {
  ACTION_BUTTON_TYPES as ABT,
  pushToParams,
  requestTo,
} from "../../components/action-buttons/ActionButtonGenerator";
import CrudMain from "../../components/crud/CrudMain";
import FormikForm from "../../components/crud/FormikForm";
import Select from "../../components/form-fields/Select";
import ListComponent from "../../components/list/ListComponent";
import Main from "../../components/main/Main";
import { getNestedValueFromPath } from "../../utils";
import MultiSelect from "../../components/form-fields/MultiSelect";
import { useTranslation } from "react-i18next";

export default function UserRole(props) {
  const [showModal, setShowModal] = useState(false);
  const [configData, setConfigData] = useState(null);
  const [refreshList, setRefreshList] = useState(false);
  const [refreshList2, setRefreshList2] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [initialValues, setInitialValues] = useState({});
  const [selectedRow, setSelectedRow] = useState(null);
  const [triggerRefresh, setTriggerRefresh] = useState(false);
  const [roleId, setRoleId] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (!getNestedValueFromPath(props, "location.state.row")) {
      props.history.goBack();
    }
    /* setRefreshList(!refreshList); */
  }, [triggerRefresh]);

  const validationSchema = yup.object({});

  const arrangeBeforePersist = (values) => {
    let payload = {
      kurumRowGrpIds: values.kurumRowCompIds,
      roleId: values.roleId,
      id: values.id,
      stId: values.stId || 90,
      userId: getNestedValueFromPath(props, "location.state.row.id"),
    };
    return payload;
  };

  const adaptDataForUpdate = (data) => {
    let adaptedData = {
      kurumRowGrpIds_1: data.kurumRowGrpIds_1,
      kurumRowGrpIds: data.kurumRowGrpIds,
      roleId: data.roleId,
      id: data.id,
      stId: data.stId,
    };
    setInitialValues(adaptedData);
  };

  const onUpdateButtonClicked = (selectedRow) => {
    setShowModal(true);
    setIsUpdating(true);
    setSelectedRow(selectedRow);
  };

  const onAddButtonClicked = () => {
    setShowModal(true);
    setIsUpdating(false);
    setInitialValues({});
  };

  const onGroupChanged = (value) => {
    const data = configData.groups.filter(
      (item) => value.indexOf(item.value) > -1
    );
    const arr = [];
    data.forEach((d) => {
      arr.push(...d.subConfigs);
    });

    setInitialValues({
      roleId,
      kurumRowGrpIds_1: value,
      kurumRowCompIds: arr.map((a) => a.value),
    });
  };

  const mapNativeDataBeforeList = (data) => {
    const arr = [];
    if (data) {
      data.map((item) => {
        (item.companyGroupEnties || []).map((entity) => {
          entity.role = item.role;
          entity.userId = item.userId;
          entity.roleRelId = item.id;
        });
      });
      data.forEach((d) => arr.push(...(d.companyGroupEnties || [])));
    }
    return arr;
  };

  const mapNativeDataBeforeList2 = (data) => {
    (data || []).map((item) => {
      item.companyGroupId = item.companyGroupEntity.id;
    });
    return data;
  };

  return getNestedValueFromPath(props, "location.state.row") ? (
    <Main>
      <div className="row">
        <div className="col-xl-12 col-xxl-12">
          <CrudMain
            onAddButtonClicked={onAddButtonClicked}
            showModal={showModal}
            setShowModal={setShowModal}
            title={t("userRole.kullaniciRol")}
            // showBackButton
            onBackButton={() => props.history.goBack()}
            unscrollable={false}
            size={"lg"}
          >
            <FormikForm
              isUpdating={isUpdating}
              entityId={selectedRow && selectedRow.id}
              entityFetchId="id"
              endPointUrl="user/role-ekle"
              fetchPointUrl="department/find"
              editPointUrl="department/update"
              configPointUrl="user/config"
              arrangeBeforePersist={arrangeBeforePersist}
              adaptDataForUpdate={adaptDataForUpdate}
              setConfigData={(data) => setConfigData(data)}
              initialValues={initialValues}
              validationSchema={validationSchema}
              closeModal={() => setShowModal(false)}
              refreshList={() => setRefreshList(!refreshList)}
              //configParameterName="groups"
              //configParameterValue={groups}
              configReqType="GET"
            >
              <Field
                name="roleId"
                label={t("userRole.rol")}
                colNumber="12"
                component={Select}
                options={configData && configData.roles}
                onChangeFunc={(opt) => setRoleId(opt)}
              />
              <Field
                name="kurumRowGrpIds_1"
                label={t("userRole.sirketGrubu")}
                colNumber="12"
                component={MultiSelect}
                options={configData && configData.groups}
                onChangeFunc={(opt) => onGroupChanged(opt)}
              />
              <Field
                name="kurumRowCompIds"
                label={t("userRole.sirketler")}
                colNumber="12"
                component={MultiSelect}
                options={configData && configData.companies}
              />
            </FormikForm>
          </CrudMain>
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-md-12">
          <h4
            style={{
              backgroundColor: "#2a2a2a",
              color: "white",
              width: "fit-content",
              padding: "6px",
            }}
          >
            {t("userRole.kullanici")}:{" "}
            {getNestedValueFromPath(props, "location.state.row.fullName")}
          </h4>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <ListComponent
            entityName="grup-şirketleri"
            //endpoint="user/role-list"
            endpoint="/user/role-list-non-default"
            keyField="selectedId"
            isMultiSelect={true}
            multiKeyField="userRoleCompanyDtos"
            sendKeyFields={[
              { param: "companyGroupId", value: "id" },
              { param: "userId", value: "userId" },
              { param: "roleRelId", value: "roleRelId" },
            ]}
            mapNativeDataBeforeList={mapNativeDataBeforeList}
            refreshList={refreshList}
            onDelete={() => setTriggerRefresh(!triggerRefresh)}
            customBody={{
              id: getNestedValueFromPath(props, "location.state.row.id"),
            }}
            columns={[
              {
                dataField: "name",
                text: t("userRole.sirketGrubu"),
                sort: true,
              },
              {
                dataField: "role.name",
                text: t("userRole.rolAdi"),
                sort: true,
              },
            ]}
            actionButtonsObject={{
              actions: [
                /*pushToParams(ABT.EDIT, onUpdateButtonClicked),*/
                requestTo(ABT.DELETE_MULTIPLE, "user/role-sil"),
              ],
              generator: DefaultActionButtonGenerator,
            }}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <ListComponent
            entityName="grup-şirketleri"
            //endpoint="user/role-list"
            endpoint="/user/role-list-default"
            keyField="id"
            isMultiSelect={true}
            multiKeyField="userRoleCompanyDtos"
            sendKeyFields={[
              { param: "companyGroupId", value: "companyGroupId" },
              { param: "userId", value: "userId" },
              { param: "roleRelId", value: "id" },
            ]}
            mapNativeDataBeforeList={mapNativeDataBeforeList2}
            refreshList={refreshList}
            onDelete={() => setTriggerRefresh(!triggerRefresh)}
            customBody={{
              id: getNestedValueFromPath(props, "location.state.row.id"),
            }}
            columns={[
              {
                dataField: "companyGroupEntity.name",
                text: t("userRole.sirketGrubu"),
                sort: true,
              },
              {
                dataField: "role.name",
                text: t("userRole.rolAdi"),
                sort: true,
              },
            ]}
            actionButtonsObject={{
              actions: [
                /*pushToParams(ABT.EDIT, onUpdateButtonClicked),*/
                requestTo(ABT.DELETE_MULTIPLE, "user/role-sil"),
              ],
              generator: DefaultActionButtonGenerator,
            }}
          />
        </div>
      </div>
    </Main>
  ) : null;
}
